import { getLoanApplicationById, getLoanById, patchSetLenderRequestId } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseLoanApplicationActionProps {
  loanId: string;
  loanApplicationId: string;
}

export const useSetLenderRequestId = ({ loanId, loanApplicationId }: UseLoanApplicationActionProps) => {
  const [loading, setLoading] = useState(false);
  const { revalidate } = useCache(getLoanApplicationById, { loanApplicationId });

  const { request } = useRequest();
  const setLenderRequestId = async ({
    id,
    lenderRequestId,
    setOpened,
  }: {
    id: string;
    lenderRequestId: string;
    setOpened: (boolean) => void;
  }): Promise<void> => {
    setLoading(true);
    try {
      await request(patchSetLenderRequestId, { id, lenderRequestId });
      revalidate();
      await waitUntilLoanApplicationIsSelected();
      setOpened(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const waitUntilLoanApplicationIsSelected = async (): Promise<void> => {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      (async function waitGetLoanApplicationSelected() {
        attempts += 1;
        if (attempts > 5) return reject();
        const loan = await getLoanById({ loanId });
        if (loan?.loanApplicationSelected) {
          return resolve();
        }
        setTimeout(await waitGetLoanApplicationSelected, 1000);
      })();
    });
  };

  return { loading, setLenderRequestId };
};
